import React from 'react';

export default function Home() {
  return (
    <div>

    <div className="home">
      <img src={process.env.PUBLIC_URL + '/assets/images/fabrics/indigosmall.jpg'} alt="Home" width="350" heigth="467" />
      <div className="home__tag_wrapper">
        <div className="home__tag">
          <img src={process.env.PUBLIC_URL + '/assets/icons/tag.gif'} alt="Gallery" height="144" width="130" />
        </div>
      </div>
    </div>

    <div className="tile">
        This website is a memorial to the life and work of L. Carlene Raper, lovingly restored from her longtime website. Aside from this message, all of the words you'll find are her own. The purpose of the website in her own words is below.
    </div>

    Above is a view of my dyeing studio, with some of the results of a day of indigo dyeing. For a bit more information about this, go here.
    <br /><br />
    I dye cotton fabrics in a wide variety of ways (go to the fabric dyeing techniques section to get an idea...) I then fashion quilts (large and small) and wallhangings, as well as balsam pillows and couch pillows from this hand-dyed fabric.
    <br /><br />
    With this site, I aim to inspire and educate, as well as to provide the opportunity for people all over the world to buy unique and satisfying objects made by an impassioned individual. Please remember, all quilt designs are copyrighted and may not be used for any purpose without my permission. If you check out the archives section, you'll get a glimpse of the stages that are involved for me in designing and doing my work.
    <br /><br />
    </div>
  );
}